module.exports = "<div class=thumbnail-list> <a class=\"left-button disable\"></a> <span class=thumbnail-anchor></span> <a class=\"right-button disable\"></a> <div class=image-controller-frame> <div class=image-controller></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/attachment-control/thumbnail-list/thumbnail-list.html
// module id = 2051
// module chunks = 50